import React from 'react';
import ProjectsList from '../collaborators/ProjectsList';

// Sunset parcial 2026-09-18: los tabs "Tablero Kanban", "Sincronización" y
// "Reportes" están ocultos hasta que haya volumen real de proyectos. En
// producción sólo hay proyectos legacy sin tareas kanban / sin timesheets,
// así que las tres vistas quedaban vacías o rotas. Los componentes viven en
// disco (ProjectKanbanBoard, SyncDashboard, ProjectsReports) por si se
// reactivan; para reactivar, restaurar el commit anterior de este archivo.
const ProjectsModule: React.FC = () => {
  const handleSelectProject = () => {
    // No-op: al no exponer Kanban ya no se navega desde la lista.
  };

  return (
    <div className="p-6">
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-gray-900">Gestión de Proyectos</h1>
        <p className="text-gray-600">Listado y edición de proyectos activos</p>
      </div>

      <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
        <ProjectsList onSelectProject={handleSelectProject} />
      </div>
    </div>
  );
};

export default ProjectsModule;
